import { render, staticRenderFns } from "./text_left.vue?vue&type=template&id=ea413bac&scoped=true&"
import script from "./text_left.vue?vue&type=script&lang=js&"
export * from "./text_left.vue?vue&type=script&lang=js&"
import style0 from "./text_left.vue?vue&type=style&index=0&id=ea413bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea413bac",
  null
  
)

component.options.__file = "text_left.vue"
export default component.exports